import React from "react";

import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import BreadcrumbGroup from "@amzn/awsui-components-react/polaris/breadcrumb-group";
import { HelpPanel } from "@amzn/awsui-components-react";
import EditContainerForm from "internal/programs/migration-acceleration-program/2024/fund-request/view/EditContainerForm";
import { EditContainerType } from "internal/programs/migration-acceleration-program/2024/fund-request/components/edit/EditContainerFactory/EditContainerComponent";
import { getClaimId, getFundRequestId } from "internal/util/helper";

const MAPClaimInvoiceEditPage = () => {
  const frId = getFundRequestId();
  const claimId = getClaimId();

  return (
    <AppLayout
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: "Dashboard", href: "/dashboard" },
            {
              text: `${frId}`,
              href: `/fund-requests/${frId}/details`,
            },
            {
              text: `${claimId}`,
              href: "#",
            },
            { text: "Edit claim invoice & payment", href: "#" },
          ]}
        />
      }
      contentType="form"
      //TODO: Implement help panel
      tools={<HelpPanel header={<h2>Overview</h2>}>Help content</HelpPanel>}
      content={
        <EditContainerForm
          editContainerType={EditContainerType.ClaimInvoice}
          claimId={claimId}
        />
      }
      navigationHide
    ></AppLayout>
  );
};

export default MAPClaimInvoiceEditPage;
